import React from 'react'

const Learnig = () => {
  return (
    <>
    <div className="dr-header">
        <div className="header-contant">
          <h1> Services</h1>
          <p>Doctor {" > "} LEARNING DISABILITY  </p>
        </div>
      </div>
    <div className="diabp">
        <h1>Learning Disability</h1>
        <div className="bp-row">
          <div className="bp-col">
            <p>
            This is usually identified at a nursery or early school level. We provide a neurological/psychiatric assessment followed by input from our Educational psychologist.
            </p>
            <p>
            Learning disabilities are disorders that affect the ability to understand or use spoken or written language, do mathematical calculations, coordinate movements, or direct attention. Although learning disabilities occur in very young children, the disorders are usually not recognized until the child reaches school age.
            </p>
         
           
          </div>
          <div className="bp-col">
            <img src="./img/learn.jpg" alt="" />
          </div>
        </div>
      </div>  
    </>
  )
}

export default Learnig
